import React from "react";
import Fallback from "../components/Fallback";

const MobileDrawer = React.lazy(() => import("./MobileDrawer"));
const MobileHeader = React.lazy(() => import("./MobileHeader"));
export const MobileDrawerScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <MobileDrawer {...props} />
  </React.Suspense>
);
export const MobileHeaderScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <MobileHeader {...props} />
  </React.Suspense>
);
